// @flow

export { normalizeIncomingPayment } from './normalize-incoming-payment';
